import { TweenMax }   from 'gsap';
import { CustomEase } from '../gsap-bonus/CustomEase';

export default class Transition {
    constructor(elem, seconds = 0.5, delay = 0) {
        this.elem = elem;
        this.seconds = seconds;
        this.delay = delay;
    }

    setHidden() {
        TweenMax.set(this.elem, {
            autoAlpha: 0
        });
    }

    fadeIn(callback = undefined) {
        TweenMax.fromTo(this.elem, this.seconds, {
            autoAlpha: 0,
            delay: this.delay,
            ease: Power0.ease,
        }, {
            autoAlpha: 1,
            onComplete: callback,
            ease: Power0.ease,
        });
    }

    staggerFadeIn(staggerDelay = 0.15, callback = undefined) {
        TweenMax.staggerFromTo(this.elem, this.seconds, {
            autoAlpha: 0,
            delay: this.delay,
            ease: Power0.ease,
        }, {
            autoAlpha: 1,
            onComplete: callback,
            ease: Power0.ease,
        }, staggerDelay);
    }

    fadeOut(callback = undefined) {
        TweenMax.fromTo(this.elem, this.seconds, {
            autoAlpha: 1,
            delay: this.delay,
            ease: Back.easeOut.config(1),
        }, {
            autoAlpha: 0,
            onComplete: callback,
            ease: Back.easeOut.config(1),
        });
    }

    fadeInUp(offset, callback = undefined) {
        TweenMax.fromTo(this.elem, this.seconds, {
            autoAlpha: 0,
            y: offset,
            scale: 0.8,
            delay: this.delay,
            ease: Back.easeOut.config(1),
        }, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            onComplete: callback,
            ease: Back.easeOut.config(1),
        });
    }

    staggerFadeInUp(offset, staggerDelay = 0.15, callback = undefined) {
        TweenMax.staggerFromTo(this.elem, this.seconds, {
            autoAlpha: 0,
            y: offset,
            delay: this.delay,
            ease: Back.easeOut.config(1),
        }, {
            autoAlpha: 1,
            y: 0,
            onComplete: callback,
            ease: Back.easeOut.config(1),
        }, staggerDelay);
    }

    staggerFadeInLeft(offset, staggerDelay = 0.15, callback = undefined) {
        TweenMax.staggerFromTo(this.elem, this.seconds, {
            autoAlpha: 0,
            x: offset,
            delay: this.delay,
            ease: Back.easeOut.config(1),
        }, {
            autoAlpha: 1,
            x: 0,
            ease: Back.easeOut.config(1),
        }, 
        staggerDelay,
        callback);
    }
}